import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANGUAGE } from "src/constants";
import translationDA from "src/languages/translationDA.json";
import translationEN from "src/languages/translationEN.json";
import translationES from "src/languages/translationES.json";
import translationLT from "src/languages/translationLT.json";
import translationNO from "src/languages/translationNO.json";
import translationRU from "src/languages/translationRU.json";
import translationSV from "src/languages/translationSV.json";

const fallbackLng = [DEFAULT_LANGUAGE];
const availableLanguages = ["en", "es", "ru", "no", "sv", "da"];

const resources = {
  en: {
    translation: translationEN,
  },
  lt: {
    translation: translationLT,
  },
  sv: {
    translation: translationSV,
  },
  no: {
    translation: translationNO,
  },
  ru: {
    translation: translationES,
  },
  es: {
    translation: translationRU,
  },
  da: {
    translation: translationDA,
  },
};

i18n
  .use(Backend) // load translations using http (default public/assets/locals/en/translations)
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .init({
    resources,
    fallbackLng, // fallback language is english.

    detection: {
      checkWhitelist: true, // options for language detection
      lookupSessionStorage: true,
      lookupLocalStorage: false,
    },

    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false, // no need for react. it escapes by default
    },
  });

//i18n.changeLanguage(DEFAULT_LANGUAGE);

export default i18n;

export const getActiveLanguage = () => {
  return (
    i18n.language ||
    (typeof window !== "undefined" && window.localStorage.i18nextLng) ||
    DEFAULT_LANGUAGE
  );
};

export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
};
